'use strict';
module.exports = ['$scope', '$q', '$filter', '$stateParams', '$state', '$uibModal', 'situationRecordService', 'datex2EnumsService', 'sourceService', 'errorHandlerService', 'translateFilter', 'situationRecordClass', 'toastService', 'sourceTranscodeFilter', 'datex2EnumsTranscodeFilter', 'zonedDateTimeToDateFilter', 'clazzNodeFilter', 'validityPeriodsToStringFilter', 'situationRecordTemplateService'
            , function ($scope, $q, $filter, $stateParams, $state, $uibModal, situationRecordService, datex2EnumsService, sourceService, errorHandlerService, translateFilter, situationRecordClass, toastService, sourceTranscodeFilter, datex2EnumsTranscodeFilter, zonedDateTimeToDateFilter, clazzNodeFilter, validityPeriodsToStringFilter, situationRecordTemplateService) {

                var mainConfig = global.ngDroAstralSituationRecordMainConfig;

                $scope.filterBoxStatus = {
                    isOpen: false
                };

                /**
                 * Filtro di ricerca corrente
                 */
                $scope.curFilter = undefined;
                /**
                 * Filtro di ricerca mostrato nei chips
                 */
                $scope.curFilterChips = undefined;

//                var defaultFilterValidityPeriods = {
//                    validityPeriodsDateStart: new Date(1900, 1, 1, 0, 0, 0)
//                    , validityPeriodsDateEnd: new Date(3100, 1, 1, 0, 0, 0)
//                };

                var defaultFilterTopLeft = {
                    x: -180,
                    y: 90,
                    z: null
                };
                var defaultFilterBottomRight = {
                    x: 180,
                    y: -90,
                    z: null
                };


                //*********************************************************************
                //**************************PAGINAZIONE****************************
                //*********************************************************************

//                var defaultPagination = {
//                    page: 1,
//                    size: mainConfig.PageSize,
//                    sort: ""
//                };

                $scope.curPaginationPage = 1;
                $scope.curPaginationSize = parseInt(mainConfig.PageSize);
                $scope.curPaginationSort = "createdDate,DESC";
                $scope.curTotItems = 0;

                //*********************************************************************

                //*******************************************************************
                //********************        EXPORT TO CSV               ***********
                //*******************************************************************

                $scope.csv = {
                    separator: ";",
                    filename: translateFilter('AstralSituationRecord.templateList') + ".csv"
                };
                $scope.getCsvHeader = function () {
                    var csvHeader = [
                        translateFilter('AstralSituationRecord.name'),
                        translateFilter('AstralSituationRecord.type'),
                        translateFilter('AstralSituationRecord.creationDate')
                    ];
                    return csvHeader;

                };

                $scope.getCsvData = function () {
                    var deferred = $q.defer();

                    var csvData = [];

                    getSources().then(function () {
                        var searchRes = $scope.situationRecordTemplatesSearchResponse.content;
                        if (searchRes) {
                            angular.forEach(searchRes, function (obj) {
                                if (obj) {
                                    var row = {
                                        name: (obj.name !== undefined && obj.name !== null) ? obj.name : "",
                                        type: (obj.clazz !== undefined && obj.clazz !== null) ? obj.clazz : "",
                                        createdDate: (obj.createdDate !== undefined && obj.createdDate !== null) ? $filter('date')(zonedDateTimeToDateFilter(obj.createdDate), "dd/MM/yyyy hh:mm") : ""
                                    };
                                    csvData.push(row);
                                }
                            });
                        }
                        ;
                        deferred.resolve(csvData);
                    }
                    , function (errors) {
                        errorHandler(errors);
                        deferred.reject();
                    });

                    return deferred.promise;
                };
                //*******************************************************************

//                //*******************************************************************
//                //********************        ORDINAMENTO TABELLA        ************
//                //*******************************************************************

                /**
                 * JSON contente la gerarchia di classi che implementa il Situation Record
                 */
                $scope.situationRecordTypesTree = undefined;
                /**
                 * Lista delle classi concrete (foglie dell'albero della gerarchia) che implementano il Situation Record
                 */
                $scope.situationRecordTypesLeaves = undefined;
                /**
                 * Enumerazioni Datex2
                 */
                $scope.datex2Enums = undefined;
                /**
                 * Sources
                 */
                $scope.situationRecordSources = undefined;

                /**
                 * Caricamento Situation Record Source
                 * @return {deferred.promise}
                 */
                function getSources() {
                    var deferred = $q.defer();
                    var params = {
                        page: 0,
                        size: 1000,
                        sort: "comment.comment.keyword"
                    };
                    sourceService.getAll(params, function (res) {

                        $scope.situationRecordSources = res.content;

                        deferred.resolve();
                    }, function (errors) {
                        errorHandler(errors);

                        deferred.reject();
                    });
                    return deferred.promise;
                }


                /**
                 * Caricamento Enumerazioni Datex2
                 * @return {deferred.promise}
                 */
                function getDatex2Enums() {
                    var deferred = $q.defer();
                    datex2EnumsService.getDatex2Enums(function (res) {
                        if (res) {
                            $scope.datex2Enums = angular.fromJson(res);
                        }
                        $scope.severityList = [];

                        deferred.resolve();
                    }, function (errors) {
                        errorHandler(errors);

                        deferred.reject();
                    });
                    return deferred.promise;
                }
                ;

                /**
                 * Caricamento tipi situation record
                 * @return {.$q@call;defer.promise}
                 */
                function getSituationRecordTypesTree() {
                    var deferred = $q.defer();
                    situationRecordService.situationRecordGetTypes(function (res) {
                        $scope.situationRecordTypesTree = res.children;

                        deferred.resolve();

                    }, function (errors) {
                        errorHandler(errors);

                        deferred.reject();
                    });
                    return deferred.promise;
                }

                function getSituationRecordTypesLeaves() {
                    if ($scope.situationRecordTypesTree) {
                        $scope.situationRecordTypesLeaves = [];
                        angular.forEach($scope.situationRecordTypesTree, function (item) {
                            setSituationRecordTypesLeaves(item);
                        });

                    }

                }
                function setSituationRecordTypesLeaves(item) {
                    if (item.children && item.children.length) {
                        //nodo intermedio
                        angular.forEach(item.children, function (child) {
                            setSituationRecordTypesLeaves(child);
                        });
                    } else {
                        //foglia
                        $scope.situationRecordTypesLeaves.push(item);
                    }

                }

                //*********************************************************************
                //**************************GESTIONE TYPEAHEAD CAUSA ******************
                //*********************************************************************
                $scope.causeMgmt = {
                    type: "enum",
                    eventId: undefined,
                    enumVal: undefined
                };
                $scope.thIsCauseAccordionCollapsed = true;
                $scope.thCauseSelected = undefined;

                $scope.thCauseReset = function () {
                    $scope.causeMgmt.eventId = undefined;
                    $scope.curFilter.cause = undefined;
                    $scope.thCauseSelected = undefined;
                    $scope.thIsCauseAccordionCollapsed = true;
                };


                $scope.thCauseSearch = function (comment) {
                    var d1 = new Date();

                    var defaultFilter = getDefaultFilter();

                    var filter = {
                        validityPeriodsDateStart: defaultFilter.validityPeriodsDateStart,
                        validityPeriodsDateEnd: defaultFilter.validityPeriodsDateEnd,
                        comment: comment
                    };

                    return searchSituationRecord(filter).then(function () {

                        $scope.thCauseResults = [];
                        if ($scope.situationRecordSearchResponse && $scope.situationRecordSearchResponse.content) {
                            for (var j = 0; j < $scope.situationRecordSearchResponse.content.length; j++) {

                                if ($scope.situationRecordSearchResponse.content[j]) {

                                    for (var i = 0; i < $scope.situationRecordSearchResponse.content[j].comments.length; i++) {
                                        var item = {
                                            comment: translateFilter('AstralSituationRecord.id')
                                                    + ": "
                                                    + $scope.situationRecordSearchResponse.content[j].id
                                                    + "-" + $scope.situationRecordSearchResponse.content[j].comments[i].comment,
                                            id: $scope.situationRecordSearchResponse.content[j].id
                                        };

                                        $scope.thCauseResults.push(item);
                                    }
                                }
                            }

                        }

                        return $scope.thCauseResults;
                    });
                };

                $scope.thCauseOnSelect = function (item) {
                    if (item) {
                        //$scope.curSituationRecord.cause = item.id;
                        $scope.causeMgmt = {
                            type: "eventId",
                            eventId: item.id,
                            enumVal: undefined
                        };

                    }
                };

                //*********************************************************************

                //*********************************************************************
                //**************************GESTIONE ERRORE ***************************
                //*********************************************************************
                /**
                 * Management errori di validaziione riscontrati al salvataggio
                 * @return {undefined}
                 */
                function errorHandler(error, successMessage, errorMessage) {

                    var validationErrors = [];
                    errorHandlerService.handle(error, successMessage, errorMessage).then(function (validErrors) {
                        validationErrors = validErrors;
                        if (validErrors)
                            toastService.createErrorToast(translateFilter('AstralSituationRecord.notValidParameter'));
                    });

                }


                //*********************************************************************

                //*********************************************************************
                //**************************RICERCA EVENTI ****************************
                //*********************************************************************

                /**
                 * Risultato ricerca eventi
                 */
                $scope.situationRecordSearchResponse = undefined;
                $scope.situationRecordTemplatesSearchResponse = undefined;
                $scope.situationRecordSearch = [];
                $scope.templateList = [];

                $scope.search = function () {

                    if ($scope.causeMgmt) {
                        if ($scope.causeMgmt.type && $scope.causeMgmt.type === "enum") {
                            if ($scope.causeMgmt.enumVal !== undefined && $scope.causeMgmt.enumVal.trim() === "")
                                $scope.causeMgmt.enumVal = undefined;

                            $scope.curFilter.cause = $scope.causeMgmt.enumVal;
                        }
                        if ($scope.causeMgmt.type && $scope.causeMgmt.type === "eventId") {
                            $scope.curFilter.cause = $scope.causeMgmt.eventId;
                        }
                    }

                    if ($scope.curFilter.eventType !== undefined && $scope.curFilter.eventType === "") {
                        $scope.curFilter.eventType = undefined;
                    }
                    if ($scope.curFilter.source !== undefined && $scope.curFilter.source === "") {
                        $scope.curFilter.source = undefined;
                    }
                    if (!$scope.curFilter.publicSiteEvidence)
                        $scope.curFilter.publicSiteEvidence = undefined;

                    if ($scope.curFilter.confidentiality === undefined) {
                        $scope.curFilter.confidentiality = undefined;
                        $scope.curFilter.confidentialityList = undefined;
                    } else {
                        $scope.curFilter.confidentialityList = [];
                        $scope.curFilter.confidentialityList.push($scope.curFilter.confidentiality);
                    }

                    if ($scope.curFilter.probabilityOfOccurrence !== undefined && $scope.curFilter.probabilityOfOccurrence.trim() === "")
                        $scope.curFilter.probabilityOfOccurrence = undefined;
                    if ($scope.curFilter.severity !== undefined && $scope.curFilter.severity.trim() === "")
                        $scope.curFilter.severity = undefined;

                    $scope.templateList = [];

                    searchSituationRecordTemplate($scope.curFilter, $scope.curPaginationPage, $scope.curPaginationSize, $scope.curPaginationSort).then(function () {
                        $scope.templateList = $scope.situationRecordTemplatesSearchResponse.content;

                        $scope.curTotItems = $scope.situationRecordTemplatesSearchResponse.totalElements;
                        if (!$scope.templateList || $scope.templateList.length === 0) {
                            var msg = translateFilter('AstralSituationRecord.noResultFound');
                            $scope.curTotItems = 0;
                            toastService.createWarningToast(msg);
                        } else {
                            $scope.filterBoxStatus = {
                                isOpen: false
                            };
                        }
                    }, function (errors) {
                        errorHandler(errors);
                    });

                };

                function getSearchFilter(filter) {
                    //verifica dei filtri impostati
                    if (!filter) {
                        filter = {};
                    }

                    //CREO UNA COPIA DEL FILTRO PERCHE' NON VOGLIO CHE I DEFAULT IMPOSTATI VENGANO RIPORTATI SUL PANNELLO DI SELEZIONE FILTRI
                    var filterCopy = angular.copy(filter, filterCopy);

                    filterCopy.clazz = situationRecordClass.getSituationRecordTypes().situationRecordFilter;
//                    if (!filterCopy.validityPeriodsDateStart) {                        
//                        filterCopy.validityPeriodsDateStart = defaultFilterValidityPeriods.validityPeriodsDateStart;
//                    }
//                    if (!filterCopy.validityPeriodsDateEnd) {
//                        filterCopy.validityPeriodsDateEnd = defaultFilterValidityPeriods.validityPeriodsDateEnd;
//                    }

                    if (!filterCopy.topLeft)
                        filterCopy.topLeft = defaultFilterTopLeft;

                    if (!filterCopy.bottomRight)
                        filterCopy.bottomRight = defaultFilterBottomRight;

                    if (filterCopy.eventType) {
                        filterCopy.eventTypeList = [filter.eventType];
                    } else {
                        filterCopy.eventTypeList = undefined;
                    }

                    if (filterCopy.source) {
                        filterCopy.sourceList = [filter.source];
                    } else {
                        filterCopy.sourceList = undefined;
                    }
                    return filterCopy;
                }

                function getSearchParams(page, size, sort) {
                    var params = {};
                    if (page !== undefined)
                        params.page = page - 1;
                    if (size)
                        params.size = size;
                    if (sort)
                        params.sort = sort;

                    return params;
                }


                /**
                 * Ricerca eventi
                 * @param {type} filter
                 * @param {type} page
                 * @param {type} size
                 * @param {type} sort
                 * @return {.$q@call;defer.promise}
                 */
                function searchSituationRecord(
                        filter
                        , page
                        , size
                        , sort
                        ) {

                    var deferred = $q.defer();

                    $scope.situationRecordSearchResponse = undefined;

                    //verifica dei filtri impostati
                    var filterCopy = getSearchFilter(filter);

                    var params = getSearchParams(page, size, sort);

                    situationRecordService.search(params, filterCopy, function (res) {
                        $scope.situationRecordSearchResponse = res;

                        deferred.resolve();
                    }, function (errors) {
                        errorHandler(errors);

                        deferred.reject();
                    });
                    return deferred.promise;
                }
                ;

                /**
                 * Ricerca templates
                 * @param {type} filter
                 * @param {type} page
                 * @param {type} size
                 * @param {type} sort
                 * @returns {.$q@call;defer.promise}
                 */
                function searchSituationRecordTemplate(
                        filter
                        , page
                        , size
                        , sort
                        ) {

                    var deferred = $q.defer();

                    $scope.situationRecordTemplatesSearchResponse = undefined;

                    //verifica dei filtri impostati
                    var filterCopy = getSearchFilter(filter);

                    var params = getSearchParams(page, size, sort);

                    situationRecordTemplateService.search(params, filterCopy, function (res) {
                        $scope.situationRecordTemplatesSearchResponse = res;

                        deferred.resolve();
                    }, function (errors) {
                        errorHandler(errors);

                        deferred.reject();
                    });
                    return deferred.promise;
                }
                ;

                //*********************************************************************

                //*********************************************************************
                //************************** CHIP FILTRI DI RICERCA *******************
                //*********************************************************************
                /**
                 * Riallineamento filtri-chips quando viene cambiato il filtro
                 * @param {type} filterItem
                 * @return {undefined}
                 */
                $scope.curFilterChange = function (filterItem) {
                    switch (filterItem) {
                        case "eventType":
                            if ($scope.curFilter.eventType) {
                                $scope.curFilterChips.eventType = clazzNodeFilter($scope.curFilter.eventType, $scope.situationRecordTypesTree);
                                $scope.curFilterChips.eventTypeChecked = true;
                            } else {
                                $scope.curFilterChips.eventType = undefined;
                                $scope.curFilterChips.eventTypeChecked = false;
                            }
                            break;
                        case "id":
                            if ($scope.curFilter.id) {
                                $scope.curFilterChips.id = $scope.curFilter.id;
                                $scope.curFilterChips.idChecked = true;
                            } else {
                                $scope.curFilterChips.id = undefined;
                                $scope.curFilterChips.idChecked = false;
                            }
                            break;
                        case "validityPeriodsDateStart":
                            if ($scope.curFilter.validityPeriodsDateStart) {
                                $scope.curFilterChips.validityPeriodsDateStart = $scope.curFilter.validityPeriodsDateStart;
                                $scope.curFilterChips.validityPeriodsDateStartChecked = true;
                            } else {
                                $scope.curFilterChips.validityPeriodsDateStart = undefined;
                                $scope.curFilterChips.validityPeriodsDateStartChecked = false;
                            }
                            break;
                        case "validityPeriodsDateEnd":
                            if ($scope.curFilter.validityPeriodsDateEnd) {
                                $scope.curFilterChips.validityPeriodsDateEnd = $scope.curFilter.validityPeriodsDateEnd;
                                $scope.curFilterChips.validityPeriodsDateEndChecked = true;
                            } else {
                                $scope.curFilterChips.validityPeriodsDateEnd = undefined;
                                $scope.curFilterChips.validityPeriodsDateEndChecked = false;
                            }
                            break;
                        case "createdDateStart":
                            if ($scope.curFilter.createdDateStart) {
                                $scope.curFilterChips.createdDateStart = $scope.curFilter.createdDateStart;
                                $scope.curFilterChips.createdDateStartChecked = true;
                            } else {
                                $scope.curFilterChips.createdDateStart = undefined;
                                $scope.curFilterChips.createdDateStartChecked = false;
                            }
                            break;
                        case "createdDateEnd":
                            if ($scope.curFilter.createdDateEnd) {
                                $scope.curFilterChips.createdDateEnd = $scope.curFilter.createdDateEnd;
                                $scope.curFilterChips.createdDateEndChecked = true;
                            } else {
                                $scope.curFilterChips.createdDateEnd = undefined;
                                $scope.curFilterChips.createdDateEndChecked = false;
                            }
                            break;
                        case "source":
                            if ($scope.curFilter.source) {
                                $scope.curFilterChips.source = $scope.curFilter.source;
                                $scope.curFilterChips.sourceChecked = true;
                            } else {
                                $scope.curFilterChips.source = undefined;
                                $scope.curFilterChips.sourceChecked = false;
                            }
                            break;
                        case "publicSiteEvidence":
                            if ($scope.curFilter.publicSiteEvidence) {
                                $scope.curFilterChips.publicSiteEvidence = $scope.curFilter.publicSiteEvidence;
                                $scope.curFilterChips.publicSiteEvidenceChecked = true;
                            } else {
                                $scope.curFilterChips.publicSiteEvidence = undefined;
                                $scope.curFilterChips.publicSiteEvidenceChecked = false;
                            }
                            break;
//                        TODO: case "cause":
//                            if ($scope.curFilter.cause) {
//                                $scope.curFilterChips.cause = $scope.curFilter.cause;
//                                $scope.curFilterChips.causeChecked = true;
//                            } else {
//                                $scope.curFilterChips.cause = undefined;
//                                $scope.curFilterChips.causeChecked = false;
//                            }
//                            break;
                        case "confidentiality":
                            if ($scope.curFilter.confidentiality) {
                                $scope.curFilterChips.confidentiality = $scope.curFilter.confidentiality;
                                $scope.curFilterChips.confidentialityChecked = true;
                            } else {
                                $scope.curFilterChips.confidentiality = undefined;
                                $scope.curFilterChips.confidentialityChecked = false;
                            }
                            break;
                        case "probabilityOfOccurrence":
                            if ($scope.curFilter.probabilityOfOccurrence) {
                                $scope.curFilterChips.probabilityOfOccurrence = $scope.curFilter.probabilityOfOccurrence;
                                $scope.curFilterChips.probabilityOfOccurrenceChecked = true;
                            } else {
                                $scope.curFilterChips.probabilityOfOccurrence = undefined;
                                $scope.curFilterChips.probabilityOfOccurrenceChecked = false;
                            }
                            break;
                        case "severity":
                            if ($scope.curFilter.severity) {
                                $scope.curFilterChips.severity = $scope.curFilter.severity;
                                $scope.curFilterChips.severityChecked = true;
                            } else {
                                $scope.curFilterChips.severity = undefined;
                                $scope.curFilterChips.severityChecked = false;
                            }
                            break;
                        case "comment":
                            if ($scope.curFilter.comment) {
                                $scope.curFilterChips.comment = $scope.curFilter.comment;
                                $scope.curFilterChips.commentChecked = true;
                            } else {
                                $scope.curFilterChips.comment = undefined;
                                $scope.curFilterChips.commentChecked = false;
                            }
                            break;
                        default:
                            break;
                    }
                };
                /**
                 * Riallineamento filtri-chips quando viene selezionato/deselezionato il chip
                 * @param {type} filterItem
                 * @return {undefined}
                 */
                $scope.curFilterChipsChange = function (filterItem) {
                    switch (filterItem) {
                        case "eventType":
                            if ($scope.curFilterChips.eventTypeChecked) {
                                $scope.curFilter.eventType = $scope.curFilterChips.eventType.element;
                            } else {
                                $scope.curFilter.eventType = undefined;
                            }
                            break;
                        case "id":
                            if ($scope.curFilterChips.idChecked) {
                                $scope.curFilter.id = $scope.curFilterChips.id;
                            } else {
                                $scope.curFilter.id = undefined;
                            }
                            break;
                        case "validityPeriodsDateStart":
                            if ($scope.curFilterChips.validityPeriodsDateStartChecked) {
                                $scope.curFilter.validityPeriodsDateStart = $scope.curFilterChips.validityPeriodsDateStart;
                            } else {
                                $scope.curFilter.validityPeriodsDateStart = undefined;
                            }
                            break;
                        case "validityPeriodsDateEnd":
                            if ($scope.curFilterChips.validityPeriodsDateEndChecked) {
                                $scope.curFilter.validityPeriodsDateEnd = $scope.curFilterChips.validityPeriodsDateEnd;
                            } else {
                                $scope.curFilter.validityPeriodsDateEnd = undefined;
                            }
                            break;
                        case "createdDateStart":
                            if ($scope.curFilterChips.createdDateStartChecked) {
                                $scope.curFilter.createdDateStart = $scope.curFilterChips.createdDateStart;
                            } else {
                                $scope.curFilter.createdDateStart = undefined;
                            }
                            break;
                        case "createdDateEnd":
                            if ($scope.curFilterChips.createdDateEndChecked) {
                                $scope.curFilter.createdDateEnd = $scope.curFilterChips.createdDateEnd;
                            } else {
                                $scope.curFilter.createdDateEnd = undefined;
                            }
                            break;
                        case "source":
                            if ($scope.curFilterChips.sourceChecked) {
                                $scope.curFilter.source = $scope.curFilterChips.source;
                            } else {
                                $scope.curFilter.source = undefined;
                            }
                            break;
                        case "publicSiteEvidence":
                            if ($scope.curFilterChips.publicSiteEvidenceChecked) {
                                $scope.curFilter.publicSiteEvidence = $scope.curFilterChips.publicSiteEvidence;
                            } else {
                                $scope.curFilter.publicSiteEvidence = undefined;
                            }
                            break;

//                        TODO: case "cause":
//                            if ($scope.curFilterChips.causeChecked) {
//                                $scope.curFilter.cause = $scope.curFilterChips.cause;
//                            } else {
//                                $scope.curFilter.cause = undefined;
//                            }
//                            break;

                        case "confidentiality":
                            if ($scope.curFilterChips.confidentialityChecked) {
                                $scope.curFilter.confidentiality = $scope.curFilterChips.confidentiality;
                            } else {
                                $scope.curFilter.confidentiality = undefined;
                            }
                            break;
                        case "probabilityOfOccurrence":
                            if ($scope.curFilterChips.probabilityOfOccurrenceChecked) {
                                $scope.curFilter.probabilityOfOccurrence = $scope.curFilterChips.probabilityOfOccurrence;
                            } else {
                                $scope.curFilter.probabilityOfOccurrence = undefined;
                            }
                            break;
                        case "severity":
                            if ($scope.curFilterChips.severityChecked) {
                                $scope.curFilter.severity = $scope.curFilterChips.severity;
                            } else {
                                $scope.curFilter.severity = undefined;
                            }
                            break;
                        case "comment":
                            if ($scope.curFilterChips.commentChecked) {
                                $scope.curFilter.comment = $scope.curFilterChips.comment;
                            } else {
                                $scope.curFilter.comment = undefined;
                            }
                            break;

                        default:
                            break;
                    }
                };

                /**
                 *  Riallineamento tutti filtri-chips
                 * @return {undefined}
                 */
                function setCurFilterChips() {
                    $scope.curFilterChips = JSON.parse(JSON.stringify($scope.curFilter));
                    $scope.curFilterChange("eventType");
                    $scope.curFilterChange("id");
                    $scope.curFilterChange("validityPeriodsDateStart");
                    $scope.curFilterChange("validityPeriodsDateEnd");
                    $scope.curFilterChange("createdDateStart");
                    $scope.curFilterChange("createdDateEnd");
                    $scope.curFilterChange("source");
                    $scope.curFilterChange("publicSiteEvidence");
                    //TODO: $scope.curFilterChange ("cause");
                    $scope.curFilterChange("confidentiality");
                    $scope.curFilterChange("probabilityOfOccurrence");
                    $scope.curFilterChange("severity");
                    $scope.curFilterChange("comment");
                }
                ;

                //*********************************************************************

                //*********************************************************************
                //**************************GESTIONE EVENTI ****************************
                //*********************************************************************
                //
                //*********************************************************************

                function getDefaultFilter() {
                    var defaultFilter = {
                        clazz: situationRecordClass.getSituationRecordTypes().situationRecordFilter
                        , id: undefined
                        , validityPeriodsDateStart: undefined
                        , validityPeriodsDateEnd: undefined
                        , topLeft: undefined
                        , bottomRight: undefined
                        , eventType: undefined
                        , eventTypeList: undefined
                        , createdDateStart: undefined
                        , createdDateEnd: undefined
                        , severity: undefined
                        , validityStatus: undefined
                        , probabilityOfOccurrence: undefined
                        , confidentiality: undefined
                        , cause: undefined
                        , source: undefined
                        , sourceList: undefined
                        , comment: undefined
                        , publicSiteEvidence: undefined
                        , comment: undefined
                    };
                    return defaultFilter;
                }

                $scope.resetFilter = function () {

                    $scope.curFilter = getDefaultFilter();

                    setCurFilterChips();

                    $scope.thCauseReset();
                };

                //*********************************************************************
                //********************  TEMPLATES - CURL OPERATIONS  ******************
                //*********************************************************************
//                function formatCurSituationRecordDates(situationRecord) {
//                    if (situationRecord.createdDate)
//                        situationRecord.createdDate = zonedDateTimeToDateFilter(situationRecord.createdDate);
//                    if (situationRecord.updatedDate)
//                        situationRecord.updatedDate = zonedDateTimeToDateFilter(situationRecord.updatedDate);
//                    if (situationRecord.validityPeriods) {
//                        angular.forEach(situationRecord.validityPeriods, function (period) {
//                            if (period.dateStart)
//                                period.dateStart = zonedDateTimeToDateFilter(period.dateStart);
//                            if (period.dateEnd)
//                                period.dateEnd = zonedDateTimeToDateFilter(period.dateEnd);
//                        });
//                    }
//                    ;
//                }

                $scope.openTemplate = function (template) {

                    $state.go('situation-record-template-mgmt', {template: template, curSearchTemplateFilter: $scope.curFilter});
                };
                $scope.createFromTemplate = function (template) {
                    situationRecordTemplateService.createFromTemplate({id: template.id}, function (res) {
                        var ret = res;
                        delete ret.$promise;
                        delete ret.$resolved;
                        //correggo i campi data
                        situationRecordClass.formatCurSituationRecordDates(ret);

                        $state.go('situation-record-new', {situationRecordFromTemplate: ret, curSearchTemplateFilter: $scope.curFilter});

                    }, function (errors) {
                        errorHandler(errors);
                    });


                };

                $scope.deleteTemplate = function (template) {

                    var bodyMessage = "";
                    if (template.name) {
                        bodyMessage = template.name.substring(0, 20);
                        if (template.name.length > 20) {
                            bodyMessage = bodyMessage + " ...";
                        }
                    }

                    var dialogInst = $uibModal.open({
                        template: require('../modal/modalQuest.html'),
                        controller: 'modalQuestCtrl',
                        size: 'md',
                        resolve: {
                            params: function () {
                                return {
                                    headerMessage: translateFilter('AstralSituationRecord.attention'),
                                    bodyMessage: translateFilter('AstralSituationRecord.deleteItemQuest') + "<br><br>" + bodyMessage,
                                    showCancelButton: true,
                                    showNoButton: false,
                                    showYesButton: true,
                                    cancelButtonText: translateFilter('AstralSituationRecord.cancel'),
                                    yesButtonText: translateFilter('AstralSituationRecord.ok')
                                };
                            }
                        }
                    });
                    dialogInst.result.then(function () {

                        situationRecordTemplateService.delete(
                                {id: template.id}
                        , function (res) {

                            var msg = translateFilter('AstralSituationRecord.deleteSuccess');
                            toastService.createSuccessToast(msg);
                            //refresh della pagina
                            $scope.search();

                        }
                        , function (errors) {
                            errorHandler(errors);
                        });
                    }, function () {
                    });
                };


                //******************************************************************* 

                (function init() {
                    getSituationRecordTypesTree().then(function () {
                        getSituationRecordTypesLeaves();
                        getDatex2Enums().then(function () {
                            getSources().then(function () {
                                $scope.resetFilter();
                                if ($stateParams.curSearchTemplateFilter) {
                                    //BACK
                                    $scope.curFilter = $stateParams.curSearchTemplateFilter;
                                }
                                setCurFilterChips();
                                $scope.search();
                            });
                        });
                    });
                })();

            }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/situationRecordTemplate/situationRecordTemplateSearchCtrl.js
// module id = 246
// module chunks = 0